import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/base/PageHero";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import ProcessSection from "@/pages/home/components/ProcessSection";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Process() {
  useDocumentMeta({
    title: "Süreç | Randevudan Rapora — d.mar Dental Görüntüleme",
    description:
      "Diş hekiminizin yönlendirmesinden randevu, çekim ve aynı gün rapor teslimine kadar d.mar Dental Görüntüleme Merkezi'nde süreç dört net adımda ilerler.",
    path: "/surec",
  });

  return (
    <SiteLayout>
      <PageHero
        crumb="Süreç"
        eyebrow="Nasıl çalışır?"
        title="Randevudan rapora kadar dört net adım"
        description="Diş hekiminizin yönlendirmesinden görüntünün kliniğinize teslimine kadar tüm süreç dijital, hızlı ve şeffaf ilerler."
      />
      <ProcessSection />
      <CtaSection />
    </SiteLayout>
  );
}